export default {
  "content": "<path d=\"M23.759 14.65l-6 7a1 1 0 01-1.518 0l-3-3.5 1.518-1.3L17 19.464l5.241-6.114 1.518 1.3z\" fill=\"#7B61FF\"/><path d=\"M12 12c2.654 0 5.095.825 6.905 2.205l-1.213 1.59C16.257 14.7 14.25 14 12 14c-4.159 0-7.256 2.308-7.882 5H12v2H3a1 1 0 01-1-1c0-4.638 4.726-8 10-8z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2.5a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};